import React, { FC } from 'react';
import { DataSourceFCO, DataSourceFCOColumn } from '../../../core/types/fcoTypes';
import { Table, Text, Card, ExtendedTableColumn } from '@lithos';

interface SchemaCardProps {
  source: DataSourceFCO;
}

const SchemaCard: FC<SchemaCardProps> = ({ source }) => {
  const columns: ExtendedTableColumn<DataSourceFCOColumn & { id: string }>[] = [
    {
      name: 'Name',
      id: 'name',
      content: (item) => {
        return <Text code>{item.name}</Text>;
      },
    },
    {
      name: 'Type',
      id: 'type',
      content: (item) => {
        return (
          <Text code>
            <>{item.type}</>
          </Text>
        );
      },
    },
  ];

  if (source.columns.length === 0) {
    return <></>;
  }

  return (
    <Card title={`Schema (${source.columns.length})`}>
      <Table
        columns={columns}
        items={source.columns.map((column) => ({ ...column, id: column.name ?? '' }))}
        compressed
      />
    </Card>
  );
};

export default SchemaCard;
